/*jshint esversion: 6 */
import * as manusGetter from "./ManusGetter.js";
import axios from 'axios';
import * as funcs from "../utils/showFuncs.js";
import * as ppFuncs from "../utils/PageParagraphFuncs.js";

import apiRouteNames from "../API_routes/routeFuncs";
const postParagraphsUrl = apiRouteNames.paragraphRoute;


const putErrorET = "Paragahvi uundamine ei õnnestunud. ";
const postErrorET = "Paragahvi pärimine ei õnnestunud. ";
const getErrorET = "Paragahvi pärimine ei õnnestunud. ";
const deleteErrorET = "Paragahvi kustutamine ei õnnestunud. ";

//GET

export function getParagraphByIdArray(pIdArray, pageObj) {
    //console.log("------------------------------getParagraphById GET PARAGRAPHS", pId);
    axios.post( postParagraphsUrl + 'many', {ids: pIdArray})
        .then(function (response) {
            var allData = response.data;
            pageObj.paragraphObjects = allData;
            allData.forEach(paragr => {
                if(paragr.manuses.length){
                    manusGetter.getManusByIdArray(paragr.manuses, paragr);
                }
            })
            //console.log("GET PARAGRAPHS ARRAY pIdArray", allData);
            //self.setState({footerParagraphs : allData});
        })
        .catch(function (error) {
            //console.log('GET PARAGRAPHS error', error);
            funcs.showError(getErrorET + error);
        });
}

export function getParagraphById(pId, self) {
    //console.log("------------------------------getParagraphById GET PARAGRAPHS", pId);
    axios.get( postParagraphsUrl + pId)
        .then(function (response) {
            var allData = response.data;
            //console.log("GET PARAGRAPHS 1", allData);
            if(self){
                //console.log("GET PARAGRAPHS 2", allData);
                /* allData.sort(function (a, b) {
                    return a.order - b.order;
                }); */
                /* */
                let prevFooters = self.state.footerParagraphs;
                let newFooters = prevFooters.concat([allData]);
                self.setState({footerParagraphs : newFooters});
            }
        })
        .catch(function (error) {
            console.log('GET PARAGRAPHS error', error);
            funcs.showError(getErrorET + error);
        });
}

export function getParagraphs(self) {
    axios.get( postParagraphsUrl)
        .then(function (response) {
            var allData = response.data;
            if(self){
                self.setState({paragraphs : allData});
            }
            else{
                //console.log("GET PARAGRAPHS", allData);
                return allData;
            }
        })
        .catch(function (error) {
            //console.log('GET PAGES error', error);
            funcs.showError(getErrorET + error);
        });
}


// WEBPACK FOOTER //
// ./src/Controllers/ParagraphGetter.js